/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { useState } from "react";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// Presentation page sections
// import Counters from "pages/Presentation/sections/Counters";
// import Information from "pages/Presentation/sections/Information";
// import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
// import Pages from "pages/Presentation/sections/Pages";
import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
// import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";
import TopAlert from "pages/LandingPages/TopAlert";

// Images
import bgImage from "assets/images/bg-presentation.jpg";

function Presentation() {
  const [alertVisible, setAlertVisible] = useState(true);
  return (
    <>
     {alertVisible && <TopAlert onClose={() => setAlertVisible(false)} />}
    <Box sx={{ paddingTop: alertVisible ? "30px" : "0px" }}>
      <DefaultNavbar
        routes={routes}
        // action={{
        //   type: "external",
        //   route: "https://www.creative-tim.com/product/material-kit-react",
        //   label: "free download",
        //   color: "info",
        // }}
        sticky
      />
      <MKBox
        minHeight="55vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Elections Nova Scotia{" "}
            </MKTypography>
            <MKTypography
              variant="h3"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Elections That Work For You
            </MKTypography>
           
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={10}>
          {/* <Grid item xs={12} lg={4}>
              <FilledInfoCard
                //variant="gradient"
                color="info"
                icon="info"
                title="Federal Election Information"
                description={<span style={{ fontWeight: "bold", color: "#660000" }}><i>A federal election is currently underway in Canada. Election day in Canada is April 28, 2025.</i></span>}
                action={{
                  type: "internal",
                  route: "/federalElection2025",
                  label: "Read More",
                }}
              />
            </Grid> */}
            {/* <Grid item xs={12} lg={6}>
              <FilledInfoCard
                //variant="gradient"
                color="info"
                icon="info"
                title="Elections Nova Scotia 2025-2026 Budget Estimate"
                description="2025-2026 Budget Estimate presented to the Special Committee of the House of Assembly."
                action={{
                  type: "internal",
                  route: "/budgetEstimate2025_2026",
                  label: "Read More",
                }}
              />
            </Grid> */}
            
            <Grid item xs={12} lg={6} sx={{display: "flex", alignItems: "stretch"}}>
              <FilledInfoCard
                color="info"
                icon="info"
                title="Elections Nova Scotia Continues Strategic Direction"
                description="Elections Nova Scotia releases four years strategic plan (2026-2030)."
                action={{
                  type: "internal",
                  route: "/ENStratergicPlan2026_2030",
                  label: "Read more",
                }}
              />
            </Grid>
            <Grid item xs={12} lg={6} sx={{display: "flex", alignItems: "stretch"}}>
              <FilledInfoCard
                color="info"
                icon="info"
                title="Elections Nova Scotia&#39;s Outreach Strategy Action Plan"
                description="A collaborative approach to address the needs of underserved voters."
                action={{
                  type: "internal",
                  route: "/ENSOutreachPlan",
                  label: "Read more",
                }}
              />
            </Grid>
            {/* <Grid item xs={12} lg={3} sx={{display: "flex", alignItems: "stretch"}}>
              <FilledInfoCard
                //variant="gradient"
                color="info"
                icon="info"
                title="Elections Nova Scotia Budget Estimates"
                description="Elections Nova Scotia presented the 2026-2027 budget estimates to the Special Committee of the House of Assembly on January 14, 2026."
                action={{
                  type: "internal",
                  route: "/BudgetEstimate2026_2027",
                  label: "Read More",
                }}
              />
            </Grid>  
            <Grid item xs={12} lg={3} sx={{display: "flex", alignItems: "stretch"}}>
              <FilledInfoCard
                color="info"
                icon="info"
                title="Elections Nova Scotia Annual Report 2024-2025"
                description="ENS’s annual report for the 2024–2025 fiscal year is now available."
                action={{
                  type: "internal",
                  route: "/AnnualReport2025",
                  label: "Read more",
                }}
              />
            </Grid>             */}
            {/* <Grid item xs={12} lg={4} sx={{display: "flex", alignItems: "stretch"}}>
              <FilledInfoCard
                color="info"
                icon="info"
                title="Provincial General Election 2024"
                description="The 42nd Provincial General Election was held in Nova Scotia on Tuesday, November 26, 2024."
                action={{
                  type: "internal",
                  route: "/provincialGeneralElections",
                  label: "Read more",
                }}
              />
            </Grid> */}
          </Grid>

          
        </Container>
        <Testimonials />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
      </Box>
    </>
  );
}

export default Presentation;
